export const cleanCheckboxArray = (array) => {
    return array.filter(value => value !== null)
}